import { defaultRequest } from "helpers";

export interface IOrganisation {
  _id?: string;
  name: string;
  address?: string;
  website?: string;
  active?: boolean;
  createdAt?: string;
  updatedAt?: string;
}

const getOrganisations = (active?: string) => {
  const params = active !== undefined ? `?active=${active}` : '';
  return defaultRequest.get<IOrganisation[]>(`organisations${params}`);
};

const getOrganisationById = (id: string) => defaultRequest.get<IOrganisation>(`organisations/${id}`);

const addOrganisation = (data: IOrganisation) => defaultRequest.post("organisations", data);

const updateOrganisation = (data: IOrganisation) => defaultRequest.put("organisations", data);

const deleteOrganisations = (ids: string[]) => defaultRequest.delete("organisations", { data: { objects: ids } });

export const organisationsApi = {
  getOrganisations,
  getOrganisationById,
  addOrganisation,
  updateOrganisation,
  deleteOrganisations,
};

